export default "__VITE_ASSET__Drmtq2Gz__"